import { Account, Filters } from '../types';

export const filterAccounts = (accounts: Account[], filters: Filters, searchTerm: string): Account[] => {
  return accounts.filter(account => 
    (filters.competitor === '' || account.competitor === filters.competitor) &&
    (filters.industry === '' || account.industry === filters.industry) &&
    (filters.dealStage === '' || account.dealStage === filters.dealStage) &&
    (searchTerm === '' || 
      account.competitor.toLowerCase().includes(searchTerm.toLowerCase()) ||
      account.industry.toLowerCase().includes(searchTerm.toLowerCase()) ||
      account.dealStage.toLowerCase().includes(searchTerm.toLowerCase()))
  );
};